import type { CityConfig } from "../city-template/types";

export const eauClaireConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Wisconsin Department of Health Services Vital Records office. Online, mail, or in-person options for Eau Claire County and Chippewa Valley residents.", url: "https://www.dhs.wisconsin.gov/vitalrecords/birth.htm" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Wisconsin Vital Records. Required for estate and legal matters in Eau Claire County.", url: "https://www.dhs.wisconsin.gov/vitalrecords/death.htm" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Eau Claire County Register of Deeds at 721 Oxford Ave. Certified copies for name changes and passport applications.", url: "https://www.co.eau-claire.wi.us/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Eau Claire County Clerk of Circuit Court. Required for name change passport corrections.", url: "https://www.wicourts.gov/courts/circuit/eau-claire.htm" },
  ],
  city: "Eau Claire",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "eau-claire",
  route: "/cities/eau-claire",
  title: "Emergency Passport Eau Claire, WI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Eau Claire, Wisconsin — as fast as 24 hours. Fast passport renewal and new passport applications for Eau Claire, Chippewa Falls, Altoona, and all Chippewa Valley residents. A+ BBB rated registered courier with access to Chicago Passport Agency.",
  h1: "Emergency & Expedited Passport Services in Eau Claire, WI",
  heroSubtitle: "Eau Claire and the Chippewa Valley have no local passport agency — the nearest is Chicago, about 290 miles southeast. Fast Passport Center's registered couriers deliver your documents directly to the Chicago Passport Agency, getting you a new or renewed passport as fast as 24–48 hours without the nearly 10-hour roundtrip drive.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Eau%20Claire%20Wisconsin%20downtown%20skyline%20at%20the%20confluence%20of%20the%20Chippewa%20and%20Eau%20Claire%20rivers%20with%20historic%20brick%20buildings%2C%20vibrant%20downtown%20Phoenix%20Park%20with%20walking%20paths%20along%20riverbank%2C%20UW%20Eau%20Claire%20campus%20with%20modern%20academic%20buildings%2C%20autumn%20colors%20reflecting%20on%20calm%20river%20water%2C%20warm%20golden%20afternoon%20light%2C%20professional%20cityscape%20photography%20with%20rich%20amber%20and%20teal%20tones%2C%20classic%20Midwest%20river%20city%20charm%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=eau-claire-wi-hero-001&orientation=landscape",
  heroImageAlt: "Eau Claire Wisconsin downtown at the confluence of the Chippewa and Eau Claire rivers",
  geoPosition: "44.8113;-91.4985",
  geoPlacename: "Eau Claire, Wisconsin",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 290 miles from Eau Claire — about 4.5 hours via I-94 southeast",
  },
  nearbyCitiesZips: [
    { name: "Downtown Eau Claire", zips: "54701, 54703" },
    { name: "Chippewa Falls", zips: "54729" },
    { name: "Altoona", zips: "54720" },
    { name: "Menomonie", zips: "54751" },
    { name: "Lake Hallie", zips: "54729" },
    { name: "Fall Creek", zips: "54742" },
    { name: "Augusta", zips: "54722" },
    { name: "Osseo", zips: "54758" },
    { name: "Mondovi", zips: "54755" },
    { name: "Durand", zips: "54736" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — no 10-hour roundtrip from Eau Claire required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for the Chippewa Valley" },
    { icon: "ri-building-line", title: "Chippewa Valley Hub", desc: "Serving Eau Claire, Chippewa Falls, Menomonie, Altoona, and all west-central Wisconsin" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx location in the Eau Claire area" },
  ],
  internalLinks: [
    { name: "Expedited passport in La Crosse, WI", route: "/cities/la-crosse" },
    { name: "Emergency passport help in Wausau, WI", route: "/cities/wausau" },
    { name: "Urgent passport services in Madison, WI", route: "/cities/madison-wi" },
    { name: "Wisconsin passport services overview", route: "/states/wisconsin" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Eau Claire, Wisconsin via secure registered courier to the Chicago Passport Agency (230 S Dearborn St, Chicago). Approximately 290 miles — about a 4.5-hour drive via I-94. Eau Claire's position in the heart of the Chippewa Valley, with direct I-94 access, makes overnight shipping fast and reliable. We handle the Chicago drive so Eau Claire and Chippewa Valley residents never need to navigate downtown Chicago traffic.",
  fpcOfficeDistance: "Serving Eau Claire, Chippewa Falls, Altoona, Menomonie, Lake Hallie, Fall Creek, Augusta, Osseo, Mondovi, Durand, and all Chippewa Valley communities in west-central Wisconsin",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Eau Claire and the Chippewa Valley. From the historic Water Street district and UW-Eau Claire campus to surrounding communities like Chippewa Falls, Menomonie, and Altoona — we serve all of west-central Wisconsin with direct courier access to the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve Eau Claire and all nearby Chippewa Valley communities including Chippewa Falls, Altoona, Menomonie, Lake Hallie, Fall Creek, Augusta, Osseo, Mondovi, and Durand. Eau Claire's position as the largest city in west-central Wisconsin makes it the natural hub for expedited passport services in the region.",
  howItWorksIntro: "Most Eau Claire travelers — especially UW-Eau Claire students, Chippewa Valley professionals, and area families — complete everything online and ship documents via overnight courier from any UPS or FedEx in Eau Claire. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "Eau Claire is the largest city in west-central Wisconsin with a thriving university community and growing international connections — but being far from a passport agency creates unique challenges. Here are the most common mistakes we see from Chippewa Valley travelers.",
  testimonialsIntro: "Eau Claire travelers — from UW-Eau Claire students and faculty to Chippewa Valley professionals to families throughout the region — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Eau Claire, WI? Here are the most common ones we hear from Chippewa Valley and west-central Wisconsin travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  dmvWebsite: "https://www.dot.wisconsin.gov/drivers",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Agency courier — no 10-hour drive", "Predictable turnaround for Chippewa Valley travelers", "Ideal for EAU Airport departures", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service USPS", "Good for planned travel from EAU or MSP", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Drive 290 miles to Chicago Passport Agency", "Nearly 10-hour roundtrip from Eau Claire"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Eau Claire travelers with flights within 72 hours — our couriers hand-deliver to Chicago Passport Agency, as fast as 24 hours.",
      bullets: ["24–48 hour turnaround available", "No 10-hour roundtrip to Chicago", "Chicago Agency courier — we handle the 4.5-hr drive each way"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Eau Claire adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for UW-Eau Claire faculty and Chippewa Valley professionals.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Serving all of west-central Wisconsin"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Eau Claire residents, Chippewa Valley families, and UW-Eau Claire students heading abroad.",
      bullets: ["Acceptance facility scheduling near campus", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Eau Claire residents — whether lost on campus, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Eau Claire and Chippewa Valley families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Eau Claire and Chippewa Valley residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Eau Claire WI", description: "Urgent passport processing for Eau Claire Wisconsin travelers via Chicago Passport Agency courier." },
    { name: "Expedited Passport Renewal Eau Claire WI", description: "Fast passport renewal for Eau Claire and Chippewa Valley Wisconsin residents." },
    { name: "First-Time Passport Eau Claire WI", description: "New passport application services for Eau Claire Wisconsin residents and UW-Eau Claire students." },
    { name: "Child Passport Eau Claire WI", description: "Minor passport services for Eau Claire Wisconsin families with children under 16." },
  ],
  testimonials: [
    {
      name: "Emily R.",
      location: "Eau Claire, WI — Near Water Street",
      rating: 5,
      text: "Study abroad program in London starting in 8 days. Realized my passport was expired during finals week. Fast Passport Center got me renewed in 3 days. Shipped from the UPS Store near UW-Eau Claire campus and had it in time. Lifesaver for Blugolds!",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Mike T.",
      location: "Chippewa Falls, WI",
      rating: 5,
      text: "Business trip to Tokyo with 6 days notice. My passport was valid but had less than 4 months remaining. Fast Passport Center expedited a renewal and I had it in 4 days. Couldn't believe how smooth it was for being in western Wisconsin.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Sarah L.",
      location: "Altoona, WI",
      rating: 5,
      text: "Family trip to Costa Rica and all three kids needed first-time passports. The Eau Claire Post Office was booked for 3 weeks. Fast Passport Center handled everything — all four passports arrived in 5 days. Amazing service for Chippewa Valley families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jason K.",
      location: "Menomonie, WI",
      rating: 5,
      text: "Lost my passport during a move from Menomonie to Eau Claire. Had a flight to Barcelona in 7 days. Fast Passport Center replaced it in 48 hours. The courier service to Chicago made all the difference — no way I was driving 10 hours roundtrip.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "eau-claire-1",
      name: "Eau Claire Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "225 E Madison St",
      city: "Eau Claire",
      state: "WI",
      zip: "54701",
      phone: "(715) 835-2438",
      hours: "Mon–Fri: 8:30 AM – 5:30 PM",
      distance: "Downtown Eau Claire, near city hall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for the Chippewa Valley. Appointment required. Busy during summer travel season and UW-Eau Claire breaks.",
      icon: "ri-mail-line",
    },
    {
      id: "eau-claire-2",
      name: "Eau Claire County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "721 Oxford Ave, Room 1210",
      city: "Eau Claire",
      state: "WI",
      zip: "54703",
      phone: "(715) 839-4800",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Eau Claire County Courthouse",
      website: "https://www.co.eau-claire.wi.us/",
      websiteLabel: "Eau Claire County",
      notes: "County clerk passport acceptance. No photo services — bring photos. Good alternative to post office during busy seasons.",
      icon: "ri-government-line",
    },
    {
      id: "eau-claire-3",
      name: "Chippewa Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Bridge St",
      city: "Chippewa Falls",
      state: "WI",
      zip: "54729",
      phone: "(715) 723-1110",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 12 miles north of downtown Eau Claire",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Chippewa Falls and Lake Hallie residents. Often has better appointment availability than Eau Claire locations.",
      icon: "ri-mail-line",
    },
    {
      id: "eau-claire-4",
      name: "Menomonie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "235 Main St E",
      city: "Menomonie",
      state: "WI",
      zip: "54751",
      phone: "(715) 235-5622",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 25 miles west of downtown Eau Claire",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Menomonie, UW-Stout campus, and Dunn County residents. Good alternative facility.",
      icon: "ri-mail-line",
    },
    {
      id: "eau-claire-5",
      name: "Altoona Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1400 Lynn Ave",
      city: "Altoona",
      state: "WI",
      zip: "54720",
      phone: "(715) 834-2910",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 4 miles east of downtown Eau Claire",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Altoona and eastern Eau Claire residents. Smaller facility — call ahead for availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5-hr drive to Chicago via I-94 (9-hr roundtrip)", fpc: "No — ship from Eau Claire, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Chippewa Valley Business Travel", agency: "No special support for professionals", fpc: "Experienced with Chippewa Valley business and academic travelers" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Eau Claire residents are nearly 300 miles from the nearest passport agency. Routine processing takes 8–11 weeks through standard mail. Chippewa Valley travelers should start expedited service at least 6 weeks before departure — especially during UW-Eau Claire study abroad seasons.",
    },
    {
      icon: "ri-car-line",
      title: "Driving to Chicago for a Passport",
      description: "At 290 miles each way, driving from Eau Claire to the Chicago Passport Agency is a 9-hour plus roundtrip — and they still won't let you in without a pre-scheduled appointment. Our courier service eliminates this entire ordeal.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo Specifications",
      description: "Retail photo services in the Chippewa Valley sometimes produce photos that fail Department of State standards. Photos must be exactly 2x2 inches on a white background — no glasses, no smiling with teeth showing. Always verify before submission.",
    },
    {
      icon: "ri-file-list-line",
      title: "Mixing Up DS-11 and DS-82 Forms",
      description: "DS-82 is only for adult renewals where you have your current passport in your possession. Everything else — first-time applications, lost passports, child passports — requires DS-11 and an in-person acceptance facility visit.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for UW-Eau Claire Academic Calendar",
      description: "Study abroad deadlines typically fall in March (for fall programs) and October (for spring programs). Eau Claire area acceptance facilities fill 3–4 weeks in advance during these periods. Plan ahead.",
    },
    {
      icon: "ri-global-line",
      title: "Relying on Minneapolis Agency Access",
      description: "The Minneapolis Passport Agency is closer than Chicago (about 90 miles), but it only serves Minnesota residents. Wisconsin residents must use the Chicago Passport Agency. Don't waste time driving to Minneapolis — they'll turn you away.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Eau Claire or the Chippewa Valley." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at any UPS or FedEx location in the Eau Claire area." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Chippewa Valley documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Chicago Passport Agency — no 10-hour roundtrip needed." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Eau Claire address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Eau Claire, WI?", a: "Fast Passport Center offers emergency passport processing in Eau Claire, Wisconsin in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St, Chicago) — no need to make the nearly 10-hour roundtrip drive yourself." },
    { q: "Does Eau Claire have its own passport agency?", a: "No. Wisconsin has no regional passport agency. The nearest is the Chicago Passport Agency, approximately 290 miles southeast (about 4.5 hours via I-94). The Minneapolis Passport Agency is closer at 90 miles but only serves Minnesota residents. Wisconsin travelers must use Chicago." },
    { q: "Can I use the Minneapolis Passport Agency from Eau Claire?", a: "No. The Minneapolis Passport Agency only serves Minnesota residents. Even though it's closer to Eau Claire (about 90 miles), Wisconsin residents must use the Chicago Passport Agency. Fast Passport Center's courier service handles the Chicago delivery so you don't have to worry about the distance." },
    { q: "What airport do Eau Claire travelers use?", a: "Eau Claire has the Chippewa Valley Regional Airport (EAU) for domestic connections. Most international travelers fly from Minneapolis-St. Paul International Airport (MSP), about 90 miles west, which offers extensive international routes. Chicago O'Hare (ORD) is about 290 miles southeast." },
    { q: "How much does an expedited passport cost in Eau Claire?", a: "Government fees are fixed: $130 for a first-time adult passport or $130 + $60 expedite fee for a renewed adult passport book. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Eau Claire?", a: "Walgreens (multiple Eau Claire locations), CVS (2613 N Clairemont Ave), and the UPS Store (2615 E Clairemont Ave) all offer passport photos. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve UW-Eau Claire students?", a: "Yes. We serve all University of Wisconsin-Eau Claire students, faculty, and staff. We understand study abroad deadlines, faculty conference travel, and student research programs. Turnaround as fast as 24–48 hours for emergency cases." },
    { q: "What about Chippewa Falls, Menomonie, or Altoona residents?", a: "Absolutely. Fast Passport Center serves all of the Chippewa Valley including Eau Claire, Chippewa Falls, Altoona, Menomonie, Lake Hallie, Fall Creek, Augusta, Osseo, Mondovi, and Durand. Our courier service works the same for everyone throughout west-central Wisconsin." },
  ],
  photoLocations: [
    { name: "Walgreens — Eau Claire (Clairemont)", address: "2613 N Clairemont Ave, Eau Claire, WI 54703", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS — Eau Claire (Clairemont)", address: "2611 N Clairemont Ave, Eau Claire, WI 54703", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/store-locator" },
    { name: "UPS Store — Eau Claire", address: "2615 E Clairemont Ave, Eau Claire, WI 54701", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Chippewa Falls", address: "309 E Prairie View Rd, Chippewa Falls, WI 54729", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
  ],
  dmvLocations: [
    { name: "WI DMV — Eau Claire", address: "3115 Melby St, Eau Claire, WI 54703", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Chippewa Valley DMV serving Eau Claire County. REAL ID and driver's license renewals. Appointment recommended.", featured: true },
    { name: "WI DMV — Menomonie", address: "3001 US-12, Menomonie, WI 54751", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Dunn County DMV serving Menomonie and UW-Stout area. Alternative when Eau Claire is busy.", featured: false },
  ],
  airports: [
    {
      code: "EAU",
      name: "Chippewa Valley Regional Airport",
      distance: "4 miles north of downtown Eau Claire",
      address: "3800 Starr Ave, Eau Claire, WI 54703",
      note: "Eau Claire's regional airport with domestic service to Chicago O'Hare and Minneapolis. International travelers connect through these hubs.",
      flightUrl: "https://www.eauclairewi.gov/airport",
      flightLabel: "EAU Airport",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis-St. Paul International Airport",
      distance: "90 miles west of Eau Claire via I-94 — approximately 1.5 hours",
      address: "4300 Glumack Dr, St Paul, MN 55111",
      note: "Primary international airport for Chippewa Valley travelers. Major Delta hub with extensive domestic and international routes across six continents.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "290 miles southeast of Eau Claire — approximately 4.5 hours",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Alternative international hub. Most Eau Claire travelers prefer MSP for convenience, but ORD offers additional route options.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "O'Hare Airport",
      featured: false,
    },
  ],
};